import * as mainTerms from '../mainTerms';

const adsetTitle = mainTerms.Setting.adset.title;

const adset = mainTerms.Setting.adset.default;
export const SetAdset = {
    currentAdset: {
        error: {
            fail: '선택된 ' + adset + '을 대상 '+ adset +'으로 지정하는 과정에서 오류가 발생했습니다.',
        },
    },
    deleteAdset : {
        success: '정상적으로 삭제되었습니다.',
        error: {
            fail: '정상적으로 삭제되지 못했습니다.',
        },
    },
    copyAdset: {
        success: '정상적으로 복사되었습니다.',
        error: {
            fail: '정상적으로 복사되지 못했습니다.',
        }
    },
    changeStatus: {
        success: '정상적으로 변경되었습니다.',
        error: {
            fail: '정상적으로 변경되지 못했습니다.',
        }
    },
    getResponse: {
        error: {
            fail: '정상적으로 데이터를 읽어오지 못했습니다.\n페이지를 갱신해주세요.',
            notFound: '해당 '+ adset +'가 존재하지 않습니다.',
        }
    },
    other: {
        warning: {
            invalidRequest: adsetTitle + '는 URL을 통해 직접 접근하실 수 없습니다.\n웹페이지를 통해 접근해주세요.',
        }
    },
    history: {
        error: {
            invalidAdset: '구형 ' + adset + '는 히스토리 조회를 하실 수 없습니다.'
        }
    }
};
export const EditAdset = { 
    editing: {
        success: adset + ' 수정에 성공했습니다.',
        error: {
            getResponse: '정상적으로 데이터를 읽어오지 못했습니다.\n페이지를 갱신해주세요.',
            fail: adset + ' 수정에 실패했습니다.',
            duplicatedName: '중복된 ' + adset + '명은 사용하실 수 없습니다.',
            notFound: '해당 '+ adset +'가 존재하지 않습니다.',
        },
    },
    new : {
        success: adset + ' 생성에 성공했습니다.',
        error: {
            fail: adset + ' 생성에 실패했습니다.\n다시 시도해주세요.',
            duplicatedName: '중복된 ' + adset + '명은 사용하실 수 없습니다.',
            setCurrentAdset: { 
                title: '선택된 ' + adset + ' 지정 에러',
                message: '선택된 ' + adset + '을 대상 '+ adset +'으로 지정하는 과정에서 오류가 발생했습니다.'
            },
            clearCurrentAdset: { 
                title: '선택된 ' + adset + ' 초기화 에러',
                message: '선택된 ' + adset + '을 초기화하는 과정에서 오류가 발생했습니다.',
            }
        },
    },
    other: {
        getResponse: {
            error: {
                fail: '정상적으로 데이터를 읽어오지 못했습니다.\n페이지를 갱신시켜주세요.',
            },
        },
        confirm: {
            warnIsModified: '변경 중인 내용은 저장되지 않습니다.\n정말 취소하시겠습니까?',
        },
        warning: {
            invalidRequest: adsetTitle + '는 URL을 통해 직접 접근하실 수 없습니다.\n웹페이지를 통해 접근해주세요.',
        },
    },
}